import { Temporal } from '@js-temporal/polyfill';

/**
 * Converte uma string de data para formato brasileiro (dd/mm/aaaa)
 * @param {string|null|undefined} stringDate - Data em formato string (ex: '2024-01-15', '2024/01/15')
 * @returns {string} Data formatada em pt-BR (ex: '15/01/2024') ou string vazia se inválida
 * @example
 * dateToString('2024-01-15') // '15/01/2024'
 * dateToString(null) // ''
 * dateToString('invalid') // ''
 */
export const dateToString = (stringDate) => {
    if (!stringDate || stringDate === 'null') return '';

    try {
        const value = typeof stringDate === 'string' && stringDate.includes('T')
            ? stringDate.split('T')[0]
            : stringDate;
        const date = Temporal.PlainDate.from(value);
        return date.toLocaleString('pt-BR');
    } catch {
        return '';
    }
};


/* Antigo
export const dateToString = (stringDate) => {
    if (!stringDate || stringDate === 'null') return '';

    const date = new Date(stringDate);
    if (isNaN(date.getTime())) return '';

    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const year = date.getUTCFullYear();

    return `${day}/${month}/${year}`;
};
*/

// formata campo data para DD-MM-YYYY
export function DateToStr(dateValue) {
    if (!dateValue) return null;

    try {
        const date = new Date(dateValue);
        if (isNaN(date.getTime())) return null;

        return date.toISOString().split('T')[0]; // Retorna no formato YYYY-MM-DD
    } catch {
        return null;
    }
}

export const dateToStringFull = (stringDate) => {
    if (!stringDate || stringDate === 'null') return null;

    // Criando um objeto Date a partir da string de entrada
    const date = new Date(stringDate);

    if (isNaN(date.getTime())) return null;

    // Diminuindo 3 horas
    //date.setHours(date.getHours() - 3);

    // Formatando a data como DD/MM/YYYY HH:mm
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // +1 porque getMonth() retorna de 0-11
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');

    return `${day}/${month}/${year} ${hours}:${minutes}`;
};

export function AdicionarDias(data, dias) {
    // Validações iniciais
    if (!data || typeof data !== 'string') return null;

    let ndias = parseInt(dias, 0);

    // Cria um objeto Date a partir da string de data
    // Usando regex para validar o formato YYYY-MM-DD
    if (!/^\d{4}-\d{2}-\d{2}$/.test(data)) return null;

    const date = new Date(`${data}T00:00:00`);

    // Verifica se a data é válida
    if (isNaN(date.getTime())) return null;

    // Adiciona os dias
    date.setDate(date.getDate() + ndias);

    // Formata a data de saída usando toISOString e extraindo apenas a parte da data
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
}